import {Button, Heading} from '@primer/react'
import {clsx} from 'clsx'
import {useState} from 'react'

import type {
  CopilotAgentConfirmation,
  CopilotClientConfirmation,
  CopilotClientConfirmationState,
} from '../utils/copilot-chat-types'
import {useChatState} from '../utils/CopilotChatContext'
import styles from './Confirmation.module.css'

export interface ConfirmationProps {
  confirmation: CopilotAgentConfirmation
  handleConfirmation: (
    clientConfirmation: CopilotClientConfirmation,
    confirmationTitle: string,
    onSubmit?: (accepted: boolean) => void,
  ) => void
  isLatestMessage?: boolean
}

export function Confirmation({confirmation, handleConfirmation, isLatestMessage}: ConfirmationProps) {
  const state = useChatState()
  const confirmationConfirmation = JSON.stringify(Object.values(confirmation.confirmation).sort())
  const clientConfirmationExists = state.allClientConfirmations?.includes(confirmationConfirmation)
  const {isWaitingOnCopilot, currentUserLogin} = state
  const [actionTaken, setActionTaken] = useState(clientConfirmationExists && !isLatestMessage)
  const handleUserAction = (action: CopilotClientConfirmationState) => {
    setActionTaken(true)
    handleConfirmation(
      {state: action, userLogin: currentUserLogin, confirmation: confirmation.confirmation},
      confirmation.title,
      confirmation.onSubmit,
    )
  }

  return (
    <div className={clsx('border rounded-2', styles.ConfirmationContainer)}>
      <Heading as="h3" className={styles.confirmationTitle}>
        {confirmation.title}
      </Heading>
      {confirmation.message.split('\n').map(message => (
        <p key={message} className={styles.confirmationMessage}>
          {message}
        </p>
      ))}
      {!actionTaken && (
        <div className={styles.actionButtonsContainer}>
          <Button disabled={isWaitingOnCopilot} variant="primary" onClick={() => handleUserAction('accepted')}>
            Allow
          </Button>
          <Button disabled={isWaitingOnCopilot} onClick={() => handleUserAction('dismissed')}>
            Dismiss
          </Button>
        </div>
      )}
    </div>
  )
}

try{ Confirmation.displayName ||= 'Confirmation' } catch {}